import type { ImageOps } from "../types";

export const browserImageOps: ImageOps = {
  async svgToPng(_svg: string): Promise<string> {
    throw new Error(
      "PNG generation is not supported in browser environments. Use SVG format or implement client-side image conversion."
    );
  },

  isAvailable(): boolean {
    return false;
  },
};

// Runtime guard
if (typeof window === "undefined") {
  throw new Error(
    "DataShows SDK: Browser adapter loaded in non-browser environment. Use `datashows-sdk/node` or `datashows-sdk/edge` for server environments."
  );
}
